import { createTheme } from '@mui/material'
import { themeProperties } from '@theme/index'

export const theme = createTheme(themeProperties)
